module.exports = __webpack_public_path__ + "static/media/delete-bin.6f583689.svg";